import axios from 'axios';

import { createLotusAxiosConfig } from '@/shared/api/lotus';

export interface KarmaTotalResponse {
  totalKarma: number;
}

export async function fetchKarmaTotal(
  days?: number,
  signal?: AbortSignal
): Promise<KarmaTotalResponse> {
  const config = await createLotusAxiosConfig();
  const params = days != null ? { days } : undefined;
  const response = await axios.get<KarmaTotalResponse>(
    '/greenfield/care/clinician-activity/karma/total',
    { ...config, params, signal }
  );
  return response.data;
}
